import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import compassImage from '../../assets/meo_compass.png';
import FlecheEnvoiClair from '../../assets/fleche_envoi_clair.png';
import {
  Container,
  ContentWrapper,
  LogoImage,
  LastMeoChatBubbleContainer,
  LastMeoChatText
} from './styles';
import {
  ReturnButton,
  SubmitButton,
} from '../Onboarding/styles';

const MessagePret = () => {
  const [isTyping, setIsTyping] = useState(true);
  const [text, setText] = useState('');
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [submitActive, setSubmitActive] = useState(false);
  const [onboardingChoice, ] = useState(() => localStorage.getItem('onboardingChoice'));

  const fullText = onboardingChoice === 'trouve' 
    ? "Prêt(e) à discuter avec les étudiant(e)s de ton école ?" 
    : "Prêt(e) à trouver la formation qui TE correspond ?";

  useEffect(() => {
    let currentIndex = 0;
    const typingInterval = setInterval(() => {
      if (currentIndex <= fullText.length) {
        setText(fullText.slice(0, currentIndex));
        currentIndex++;
      } else {
        setIsTyping(false);
        clearInterval(typingInterval);
      }
    }, 15);

    return () => clearInterval(typingInterval);
  }, [fullText]);

  const handleBack = () => {
    navigate('/origine-city');
  };

  const handleSubmit = () => {
    if (isTyping) return;
    setIsLoading(true);
    try {
      // Navigate to first-login
      navigate('/first-login');
    } catch (error) {
      console.error('Error during navigation:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // --- Submit Button Pointer Handlers ---
  const handleSubmitPressStart = () => {
    if (isTyping || isLoading) return;
    setSubmitActive(true);
  };

  const handleSubmitPressEnd = () => {
    if (isTyping || isLoading) return;
    setSubmitActive(false);
    // Delay to allow the "rebound" effect
    setTimeout(() => {
      handleSubmit();
    }, 150);
  };

  return (
    <Container>
      <ContentWrapper>
        <ReturnButton onClick={handleBack}>
          <img src={FlecheEnvoiClair} alt="Back" style={{ width: '24px', height: '24px' }} />
        </ReturnButton>

        <LastMeoChatBubbleContainer>
          <LastMeoChatText isVisible={text.length > 0}>
            {text}
          </LastMeoChatText>
        </LastMeoChatBubbleContainer>

        <LogoImage src={compassImage} alt="Compass Logo" />
        
        <SubmitButton
          onMouseDown={handleSubmitPressStart}
          onMouseUp={handleSubmitPressEnd}
          onMouseLeave={() => setSubmitActive(false)}
          onTouchStart={handleSubmitPressStart}
          onTouchEnd={handleSubmitPressEnd}
          disabled={isTyping || isLoading}
          active={submitActive}
          style={{
            opacity: (isTyping || isLoading) ? 0.5 : 1,
            cursor: (isTyping || isLoading) ? 'not-allowed' : 'pointer'
          }}
        >
          Allons-y !
        </SubmitButton>
      </ContentWrapper>
    </Container>
  );
};

export default MessagePret;
